import moment from "moment";
import * as types from "./types";

export const getFormattedCurrentDate: types.getFormattedCurrentDate = () =>
  moment().format("D/M/YY hh:mm a");

export const getDefaultVideoName: types.getDefaultVideoName = () =>
  `Screen Capture ${getFormattedCurrentDate()}.webm`;
